import {ajax} from '../modules/ajax';

/*
    @param string foreignIframe - src внешнего ифрейма.
    @param string filmName - если используется внешний ифрейм, то сами подставляем название.
    TODO - дописать все параметры
 */

var Trailer = class {
	constructor(wrapper) { 
		this._createElements(wrapper);
        this._addPreviews();
	}
	
	_createElements(wrapper){
        var self = this;
		this.wrapper = wrapper;
        this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
        this.extended = function(){
            try{
                return (self.param.extended + '/');
            }catch(e){
                return '';
            }
        }();
        this.frame = this.wrapper.querySelector('[data-Trailer-frame]');
        this.previews = this.wrapper.querySelector('[data-Trailer-previews]');
        this.thumbAll;
        this.moduleFrameAll = APP.modules.run(this.frame, 'data-trailer-modules');
        /* плеера может и не быть, может всталяться ифрейм */
        if(this.moduleFrameAll.uPlayer){
            this.moduleFrameAll.uPlayer[0].onActive = function() {
                self.wrapper.classList.add('js-active');
                self.wrapper.classList.remove('js-closed');
            }

            this.moduleFrameAll.uPlayer[0].onDisableActive = function() {
                self.wrapper.classList.remove('js-active');
                self.wrapper.classList.add('js-closed');
            }
        }
        else if (this.moduleFrameAll.onlinePlayer) {
            this.moduleFrameAll.onlinePlayer[0].onActive = function() {
                self.wrapper.classList.add('js-active');
                self.wrapper.classList.remove('js-closed');
            }
        }
        this.modulePreviewsAll;
        this.isSending = false;
        this.curInd = false;
        this.ajaxPath = this._defineAjaxPath();
        this.xhr = false;
        /* если у нас простой ифрейм, то без всяких запросов - просто меняем название и урл */
        this.filmName;
        this.foreignIframe;
	}

    _defineAjaxPath(){
        var part = (window.location + '').indexOf('/_src/') === -1 ? '' : '/_src/layouts/trailerModule';
        return	part;
    }

    _addPreviews () {
        if(!this.previews) return false;

        var self = this;

        this.modulePreviewsAll = APP.modules.run(this.previews, 'data-trailer-modules');
        this.thumbAll = this.previews.querySelectorAll('[data-Trailer-thumb]');

        for(var i=0,j=this.thumbAll.length; i<j; i++){
            var thumb = this.thumbAll[i];

            if(thumb.className.indexOf('js-active') !== -1) this.curInd = i;

            thumb.addEventListener('click', (function(i){return function(e){
                self._switchTab.call(self,e,i)
            }})(i), false);
        }
    }

    _switchTab(e, i){
        var newThumb = this.thumbAll[i],
            param;


        e.preventDefault();
        if(this.curInd === i) return false;

        newThumb.className = newThumb.className + ' js-active';
        if(this.curInd !== false){
          var oldThumb = this.thumbAll[this.curInd];
            oldThumb.className = oldThumb.className.replace(' js-active', '');
        }

        this.curInd = i;
        param = JSON.parse(newThumb.getAttribute('data-Trailer-thumb'));

        /* если внешний ифрейм - просто меняем урл и название, без всяких запросов и прелоадеров */
        if(param.foreignIframe){
            if(!this.foreignIframe){
                this.filmName = this.frame.querySelector('[data-trailer-filmName]');
                this.foreignIframe = this.frame.querySelector('[data-trailer-foreignIframe]');
            }

            this.filmName.innerHTML = param.filmName;
            this.foreignIframe.setAttribute('src', param.foreignIframe);

        } else {
            if(this.frame.className.indexOf('js-loading') === -1) this.frame.className = this.frame.className + ' js-loading';

            APP.modules.destroy(this.moduleFrameAll);
            delete this.moduleFrameAll;

            this._getContent(param);
        }
    }

    _getContent(param){
        var self = this,
            path = this.ajaxPath + '/movies/'+ param.movieid +'/video/'+ param.videoid +'/' + this.extended;

        if(this.xhr) this.xhr.abort();

        this.xhr = new XMLHttpRequest();
        this.xhr.open("POST", path, true);
        this.xhr.setRequestHeader("X-Request-Ajax","1");
        this.xhr.onload = function(){self._addContent.call(self, self.xhr.responseText);};
        this.xhr.send(this._jsonToQueryString(param));
    }

    _addContent(msg){
        this.xhr = false;
        this.frame.innerHTML = msg;
        this.moduleFrameAll = APP.modules.run(this.frame, 'data-trailer-modules');
        this.frame.className = this.frame.className.replace(' js-loading', '');
    }

    _jsonToQueryString(json) {
        return '?' +
            Object.keys(json).map(function(key) {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }).join('&');
    }

    del(){
        APP.modules.destroy(this.moduleFrameAll);
        if(this.modulePreviewsAll) APP.modules.destroy(this.modulePreviewsAll);

        for(var key in this){
            delete this[key];
        }
    }
};

export {Trailer};





































